import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ChatFollowUpUI from './ChatFollowUpUI.js'

class ChatFollowUpSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      chatMessageList: [],
      userMessageList: []
    }
  }

  render() {
    return (
      <ChatFollowUpUI
        context={this.props.context}
        errorList={this.state.errorList}
        chatMessageList={this.state.chatMessageList}
        userMessageList={this.state.userMessageList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getChats(context)
  }

  getChats(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chatMessages/statuses/to_follow_up`,
      cacheKey: CacheKeys.Chats('to_follow_up'),
      callback: this.getChatsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getChatsCallback = (response) => {
    this.setState({ chatMessageList: response.chatMessageList, userMessageList: response.userMessageList })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Chats('to_follow_up'))
    if (noBusy === 'noBusy')
      this.getChats(context)
    else
      this.setState({ chatMessageList: null, errorList: null },
        this.getChats(context)
      )
  }
}

export default ChatFollowUpSF
